// removed by extract-text-webpack-plugin
module.exports = {"layout":"src-layouts----index-module---layout---X7wKy"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/index.module.pcss
// module id = 303
// module chunks = 114276838955818